module.exports = __webpack_public_path__ + "static/media/emailicon.0da5d327.svg";